import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import toUpper from 'lodash/toUpper';
import { YES, LIKED, DISLIKED } from '../constants/moviesConst';
import { movieStatusMap } from '../config/movieConfig';
import { checkForShowLikeDislike } from '../selectors/moviesMetricSelector';

export interface MetricInfo {
	metricData: {
		interested?: {
			countInfo?: {
				yes?: number;
			};
		};
		sentiment?: {
			countInfo: {
				disliked: number;
				liked: number;
			};
			percentage?: number;
		};
	};
	reviewData?: {
		isAvailable: boolean;
	};
	ratingsData?: {
		IMDB?: {
			baseValue: '6.0';
			value: '10';
		};
	};
	sessionData?: {
		sessionCount: number;
		status: number;
	};
}

interface GetSentimentCountReturn {
	showLikeDislike?: boolean;
	likePercent?: number;
	totalVotes?: number;
	interestedCount?: number;
}

export const getSentimentCount = (
	metricInfo: MetricInfo,
	isUpcoming?: boolean,
): GetSentimentCountReturn => {
	let sentimentCount = {};
	if (isEmpty(metricInfo)) {
		return {};
	}
	const { metricData = {}, sessionData = {} } = metricInfo;
	const { sentiment, interested } = metricData;
	const status = get(sessionData, 'status');
	const movieStatus = get(movieStatusMap, status);

	const showLikeDislike = movieStatus ? checkForShowLikeDislike(movieStatus) : !isUpcoming;
	sentimentCount = { ...sentimentCount, showLikeDislike };

	if (showLikeDislike) {
		const likeCount = get(sentiment, `countInfo.${LIKED}`, 0);
		const dislikeCount = get(sentiment, `countInfo.${DISLIKED}`, 0);
		const likePercent = get(sentiment, 'percentage', 0);
		const totalVotes = likeCount + dislikeCount;
		sentimentCount = { ...sentimentCount, likePercent, totalVotes };
	} else {
		let interestedCount = get(interested, `countInfo.${YES}`, 0);
		if (!interestedCount) {
			const uYES = toUpper(YES);
			interestedCount = get(interested, `countInfo.${uYES}`, 0);
		}
		sentimentCount = { ...sentimentCount, interestedCount };
	}
	return sentimentCount;
};
